import { GetAdminItineraryImportResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one itinerary import's admin detail (GET /v1/admin/itinerary-imports/:id).
 * Disabled until there is an id. Gated server-side by AdminGuard; a missing id
 * returns 404 and a malformed one 400.
 */
export const useAdminItineraryImport = (id: string | undefined) => {
	return useQuery<GetAdminItineraryImportResponse>({
		queryKey: queryKeys.adminItineraryImport(id ?? ''),
		queryFn: async () => {
			const response = await api.get<GetAdminItineraryImportResponse>(`/admin/itinerary-imports/${id}`)
			return response.data
		},
		enabled: Boolean(id),
	})
}
